module.exports = __webpack_public_path__ + "media/ncs.9b55c075.mp3";